import { HashSet } from "../Utils/HashSet";
import { Link, LinkType } from "./Link";
import { LinkMember } from "./LinkMember";
import { IfTable, IfEntry } from "../InfoSets/IfTable";
import { Device } from "./Device";
import { DeviceKey, IfKey } from "./Keys";
import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { Guid } from "../Utils/Guid";

export class LinkMemberSet implements Iterable<LinkMember> {
	private _linkMemberSet: HashSet<LinkMember>;
	private _parentLink: Link;

	public get NetworkMemberCount(): number {
		var memberCount = 0;

		this._linkMemberSet.ForEach((linkMember) => {
			if (!linkMember.IsNetworkMember)
				return;
			memberCount++;
		});

		return memberCount;
	}

	constructor(parentLink: Link) {
		this._linkMemberSet = new HashSet<LinkMember>();
		this._parentLink = parentLink;
	}

	public AddDeviceLinks(device: Device, ifEntry: IfEntry): LinkMember {
		var linkMember: LinkMember = null;

		var deviceKey: DeviceKey = null;
		var ifKey: IfKey = null;

		if ((device != null) && (ifEntry != null)) {
			ifKey = IfKey.Create(device, ifEntry);
		}
		else if (device != null) {
			deviceKey = DeviceKey.Create(device);
		}

		linkMember = this.Find(device, ifEntry);
		if (linkMember == null) {
			linkMember = new LinkMember(deviceKey, ifKey);
			linkMember.Device = device;
			linkMember.IfEntry = ifEntry;
			linkMember.IsNetworkMember = device.IsNetworkDevice();

			if (ifEntry == null) {
				//if (device.Links.IsEmpty)
				//    device.Links.Add(linkMember.ParentLink);

				device.Links.Add(this._parentLink);
			}
			else {
				ifEntry.LinkMember = linkMember;
			}

			this._linkMemberSet.Add(linkMember);
		}
		else {
			// TODO: 
		}

		// ASSOCIATE to PARENT
		if ((linkMember != null) && (this._parentLink != null))
			linkMember.ParentLink = this._parentLink;

		return (linkMember);
	}

	public Add(linkMember: LinkMember): boolean {
		if (this._linkMemberSet.Contains(linkMember))
			return false;

		this._linkMemberSet.Add(linkMember);
		return true;
	}

	public Clear() {
		this._linkMemberSet.ForEach((linkMember) => {
			if (linkMember.IfEntry != null)
				linkMember.IfEntry.RemoveLink();
			else if (linkMember.Device != null)
				linkMember.Device.RemoveLink(linkMember.ParentLink);
		});

		this._linkMemberSet.Clear();
	}

	//public Contains(linkMember: LinkMember): boolean {
	//	return this._linkMemberSet.Some((linkMember) => {
	//		return linkMember.Equals(linkMember);
	//	});
	//}

	public ContainsHistoricalMembers(): boolean {
		return this._linkMemberSet.Some((linkMember) => {
			return linkMember.LinkType == LinkType.Historical;
		});
	}

	public get Count(): number {
		return this._linkMemberSet.Count;
	}

	public Find(device: Device, ifEntry: IfEntry): LinkMember {
		var linkMember: LinkMember = null;

		this._linkMemberSet.Some((member) => {
			if (member.Device !== device)
				return;

			if (ifEntry) {
				if (member.IfEntry !== ifEntry)
					return;
			}

			linkMember = member;
			return true;
		});

		return (linkMember);
	}

	public FindByIdAndEntry(deviceGUID: Guid, ifEntry?: IfEntry): LinkMember {
		var linkMember: LinkMember = null;

		this._linkMemberSet.Some((member) => {
			if (!member.Device.HasGUID)
				return;

			if (!member.Device.GUID.Equals(deviceGUID))
				return;

			if (ifEntry != null) {
				if (member.IfEntry == null)
					return;
				if (member.IfEntry.IfIndex != ifEntry.IfIndex)
					return;
			}
			else {
				if (member.IfEntry != null)
					return;
			}

			linkMember = member;
			return true;
		});

		return (linkMember);
	}

	public FindByIdAndIndex(deviceGUID: Guid, ifIndex: number = -1, ifName: string = null): LinkMember {
		var linkMember: LinkMember = null;

		this._linkMemberSet.Some((member) => {
			if (!member.HasDevice)
				return;
			if (member.Device.GUID != deviceGUID)
				return;

			if (ifIndex >= 0) {
				if (member.IfEntry == null)
					return;
				if (member.IfEntry.IfIndex != ifIndex)
					return;
			}
			else if (!ifName) {
				// TODO: 
			}
			else {
				if (member.IfEntry != null)
					return;
			}

			linkMember = member;
			return true;;
		});

		return (linkMember);
	}

	public FindRemoteMember(localDevice: Device, localIfEntry: IfEntry): LinkMember {
		var linkMember: LinkMember = null;

		if (this._linkMemberSet.Count == 2) {
			this._linkMemberSet.Some((member) => {

				if (member.Device == localDevice)
					return;

				if (localIfEntry != null) {
					if (member.IfEntry == localIfEntry)
						return;
				}

				linkMember = member;
				return true;
			})
		}

		return (linkMember);
	}

	public FindRemoteMemberById(localDeviceGUID: Guid, localIfIndex: number): LinkMember {
		var linkMember: LinkMember = null;

		if (this._linkMemberSet.Count == 2) {
			this._linkMemberSet.Some((member) => {
				if (member.Device.GUID == localDeviceGUID)
					return;

				if (member.IfEntry != null) {
					if (member.IfEntry.IfIndex == localIfIndex)
						return;
				}

				linkMember = member;
				return true;
			});
		}

		return (linkMember);
	}

	public GetFirstMember(): LinkMember {
		return this._linkMemberSet.First();
	}

	public GetFirstIfEntryMember(): LinkMember {
		var ifLinkMember: LinkMember = null;

		if (this._linkMemberSet.Count > 0) {
			this._linkMemberSet.Some((member) => {

				if (!member.HasIfKey)
					return;
				ifLinkMember = member;
				return true;
			});
		};

		return (ifLinkMember);
	}

	public GetNetworkMember(): LinkMember {
		if (this._linkMemberSet.Count > 0)
			return this.GetNetworkMembers().First();
		else
			return null;
	}

	public GetNetworkMembers(): LinkMemberSet {
		var networkMembers = new LinkMemberSet(null);

		this._linkMemberSet.ForEach((member) => {
			if (member.IsNetworkMember)
				networkMembers.Add(member);
		});

		return networkMembers;
	}

	public GetSwitchMembers(): LinkMemberSet {
		var switchMembers = new LinkMemberSet(null);

		this._linkMemberSet.ForEach((member) => {
			if (member.IsSwitchMember)
				switchMembers.Add(member);
		});

		return switchMembers;
	}

	public GetWirelessApMembers(): LinkMemberSet {
		var apMembers = new LinkMemberSet(null);

		this._linkMemberSet.ForEach((member) => {
			if (member.IsWirelessApMember)
				apMembers.Add(member);
		});

		return apMembers;
	}

	public GetNonNetworkMembers(): LinkMemberSet {
		var nonNetworkMembers = new LinkMemberSet(null);

		this._linkMemberSet.ForEach((member) => {
			if (!member.IsNetworkMember)
				nonNetworkMembers.Add(member);
		});

		return nonNetworkMembers;
	}

	public GetSourceMember(): LinkMember {
		var srcLinkMember: LinkMember = null;

		srcLinkMember = this.GetFirstIfEntryMember();
		if (srcLinkMember == null) {
			srcLinkMember = this.GetFirstMember();
		}

		return (srcLinkMember);
	}

    public GetUniqueDeviceIfEntry(device: Device): IfEntry {
        var foundIfEntry: IfEntry = null;

        this.Some((linkMember) => {
            if (linkMember == null)
                return false;
            if (linkMember.Device != device)
                return false;
            if (linkMember.IfEntry == null)
                return false;
            if (foundIfEntry == null) {
                foundIfEntry = linkMember.IfEntry;
                return false;
            }
            else {
                foundIfEntry = null;
                return true;
            }
        }, this);

        return foundIfEntry;
    }

	public Remove(device: Device, ifEntry: IfEntry): void {
		var linkMember = this.Find(device, ifEntry);
		if (linkMember != null) {
			this._linkMemberSet.Remove(linkMember);

			if (ifEntry != null) {
				ifEntry.RemoveLink();
			}

			if (device != null)
				device.RemoveLink(linkMember.ParentLink);
		}
	}

	public RemoveAll(): void {
		this._linkMemberSet.ForEach((member) => {
			if (member.HasIfEntry)
				member.IfEntry.RemoveLink();
			else if (member.HasDevice)
				member.Device.RemoveLink(member.ParentLink);
		});

		this._linkMemberSet.Clear();
	}

	public First(): LinkMember {
		return this._linkMemberSet.First();
	}

	public SetLinkType(linkType: LinkType): void {
		this._linkMemberSet.ForEach((member) => {
			member.LinkType = linkType;
		});
	}

	public ToArray(): LinkMember[] {
		return this._linkMemberSet.ToList().Values;
	}

	public ForEach(callbackfn: (value: LinkMember, index: number, array: LinkMember[]) => void, thisArg?: any): void {
		this._linkMemberSet.ForEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: LinkMember, index: number, array: LinkMember[]) => boolean, thisArg?: any): boolean {
		return this._linkMemberSet.Some(callbackfn, thisArg);
	}

	public Every(callbackfn: (value: LinkMember, index: number, array: LinkMember[]) => boolean, thisArg?: any): boolean {
		return this._linkMemberSet.Every(callbackfn, thisArg);
	}
}
